import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Button, HelmetWrapper, SkipNavContent } from 'sarsaparilla';
import { TextInput } from '../../../../ui-lottery/src/components/inputs';
import { CurrentUserProps } from '../../props/currentUser';
import { generateApiKey } from '../../actions/apiKey';
import { updateCurrentUser } from '../../actions/currentUser';
import { getCurrentUser } from '../../reducers/currentUser';
import ClickwrapModal from './ClickwrapModal';
import styles from './ProfilePage.scss';

const propTypes = {
  currentUser: CurrentUserProps,
  generateApiKey: PropTypes.func.isRequired,
  updateCurrentUser: PropTypes.func.isRequired
};

const defaultProps = {};

export class ProfilePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showEnableDeveloperAccessAgreementModal: false
    };

    this.generateApiKey = this.generateApiKey.bind(this);
    this.goEditProfile = this.goEditProfile.bind(this);
  }

  handleProfileUpdateError(error) {
    // TODO - Handle errors.
    console.log('TODO: Need to handle this error. ', error);
  }

  generateApiKey() {
    this.props.generateApiKey()
      .then((apiKey) => this.props.updateCurrentUser({ apiKey }))
      .catch((error) => {
        this.handleProfileUpdateError(error);
      });
  }

  goEditProfile() {
    window.location.href = `${process.env.SITE_ROOT}/account/profile`;
  }

  enableDeveloperAccess = () => {
    this.setState({
      showEnableDeveloperAccessAgreementModal: true
    });
  };

  onModalCancel = () => {
    this.setState({
      showEnableDeveloperAccessAgreementModal: false
    });
  };

  onModalContinue = () => {
    this.setState({
      showEnableDeveloperAccessAgreementModal: false
    });
    this.props.updateCurrentUser({ isDeveloper: true })
      .then(() => {
        this.generateApiKey();
      })
      .catch((error) => {
        this.handleProfileUpdateError(error);
      });
  };

  render() {
    const { currentUser } = this.props;

    if (!currentUser.loggedIn) {
      return (
        <div>Please <Link to="/login">login</Link> to view you profile</div>
      );
    }

    return (
      <SkipNavContent>
        <HelmetWrapper title="RIDB Profile" />
        <main role="main" className={styles['profile-page']}>
          <h1>Profile</h1>
          <div className={styles['modal-box']}>
            <div className={styles.row}>
              <div className={styles.cell}>
                <TextInput
                  id="profile-fname"
                  label="First Name"
                  value={currentUser.account.firstName}
                  readOnly />
              </div>
              <div className={styles.cell}>
                <TextInput id="profile-lname" label="Last Name" value={currentUser.account.lastName} readOnly />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.cell}>
                <TextInput id="profile-email" label="Email" value={currentUser.account.email} readOnly />
              </div>
              <div className={styles.cell}>
                <TextInput id="profile-phone" label="Phone" value={currentUser.account.homePhone} readOnly />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.cell}>
                <TextInput
                  id="profile-apikey"
                  label="APIKey"
                  value={currentUser.apiKey.apiKey}
                  selectAllOnFocus
                  readOnly />
              </div>
              <div className={`${styles.cell} ${styles.buttons}`}>
                {
                  currentUser.isDeveloper
                    ? <Button appearance="tertiary" onClick={this.generateApiKey}>Generate New APIKey</Button>
                    : <Button appearance="secondary" onClick={this.enableDeveloperAccess}>Enable Developer Access</Button>
                }
              </div>
              {
                this.state.showEnableDeveloperAccessAgreementModal &&
                <ClickwrapModal
                  shouldPresent
                  onCancel={this.onModalCancel}
                  onContinue={this.onModalContinue} />
              }
            </div>
            <div className={styles.row}>
              <div className={`${styles.cell} ${styles.buttons}`}>
                <Button onClick={this.goEditProfile}>Edit Recreation.gov Profile</Button>
              </div>
            </div>
          </div>
        </main>
      </SkipNavContent>
    );
  }
}

ProfilePage.propTypes = propTypes;
ProfilePage.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ generateApiKey, updateCurrentUser }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
